import Vue from 'vue'
import Vuex from 'vuex'

import base from './modules/base'
// import teach from './modules/teach'
// import course from './modules/course'
// import contest from './modules/contest'
// import problem from './modules/problem'
// import learing from './modules/learing'

Vue.use(Vuex)

export default () => {
  return new Vuex.Store({
    modules: {
      base,
      // teach,
      // course,
      // problem,
      // contest,
      // learing
    },
    strict: process.env.NODE_ENV !== 'production'
  })
}